import React from "react";
import axios from "axios";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const PRESETS = [["montador", "Montagem"], ["fabrica", "Fábrica"], ["entrega", "Entrega/Transporte"], ["cliente_ambiente", "Cliente/Ambiente"]];
const CONCLUSOES = [["montador", "Montador"], ["fabrica", "Fábrica"], ["entrega", "Entrega"], ["cliente_ambiente", "Cliente/Ambiente"], ["vistoria", "Necessita vistoria"]];
const DESTINOS = [["", "Destino padrão da conclusão"], ["revisao", "Revisão"], ["assistencia", "Assistência"], ["garantia", "Garantia"],
  ["tratativa_fabrica", "Tratativa Fábrica"], ["tratativa_logistica", "Entrega/Transporte"], ["cliente_ambiente", "Cliente/Ambiente"], ["outra", "Outra"], ["nao_proceder", "Não proceder"]];
const ROTULO = { montador: "Montador", fabrica: "Fábrica", entrega: "Entrega", cliente_ambiente: "Cliente/Amb." };

function Barras({ prob, titulo }) {
  if (!prob) return null;
  return (
    <div className="mt-1.5">
      <div className="text-[10px] uppercase tracking-widest text-white/40">{titulo} — apoio, não decide</div>
      {Object.entries(prob).map(([k, v]) => (
        <div key={k} className="flex items-center gap-2 text-[11px]">
          <span className="w-20 text-white/60">{ROTULO[k] || k}</span>
          <div className="flex-1 h-1.5 rounded bg-white/10"><div className="h-1.5 rounded bg-[#FFCC00]" style={{ width: `${v}%` }} /></div>
          <span className="w-8 text-right font-bold">{v}%</span>
        </div>
      ))}
    </div>
  );
}

function ItemAvaliacao({ sid, it, av, servs = [], busy, acao }) {
  const [preset, setPreset] = React.useState(it.preset || "montador");
  const [conc, setConc] = React.useState("montador");
  const [dest, setDest] = React.useState("");
  const garStatus = av?.garantia_id ? (servs.find(s => s.id === av.garantia_id) || {}).status : null;
  const prob = av?.probabilidade_final || av?.probabilidade_inicial;
  const sugerida = prob ? Object.entries(prob).sort((a, b) => b[1] - a[1])[0][0] : null;
  const decidida = av?.status === "avaliada";
  return (
    <div className="rounded-xl border border-white/10 bg-[#142766]/40 px-3 py-2 text-xs" data-testid={`demo-avaliacao-item-${it.n}`}>
      <div className="flex flex-wrap items-center justify-between gap-2">
        <div><b>Avaliação {it.n}</b> <span className="text-white/40">mãe {it.pim_mae} · há {it.dias_contexto}d</span>
          <span className="ml-2 text-[#6FA6FF] font-bold">{av?.status || "—"}</span></div>
        <span className="text-white/40">{(av?.fotos || []).length} fotos · vídeo {av?.video ? "✓" : "—"}</span>
      </div>
      <Barras prob={av?.probabilidade_inicial} titulo="Triagem inicial (questionário)" />
      {av?.probabilidade_final && <Barras prob={av.probabilidade_final} titulo="Probabilidade final (checklist técnico)" />}
      {!decidida && (
        <div className="mt-2 flex flex-wrap gap-1.5 items-center">
          <select value={preset} onChange={e => setPreset(e.target.value)} data-testid={`demo-avaliacao-preset-${it.n}`}
            className="bg-[#142766] border border-[#126BFF]/30 rounded-lg text-[11px] font-bold px-2 py-1">
            {PRESETS.map(([v, l]) => <option key={v} value={v}>Relato compatível: {l}</option>)}
          </select>
          <button disabled={busy} onClick={() => acao("questionario", { avaliacao_id: it.avaliacao_id, preset })} data-testid={`demo-avaliacao-questionario-${it.n}`}
            className="px-2 py-1 rounded bg-[#126BFF]/15 text-[#6FA6FF] font-bold">Cliente responde questionário</button>
          <button disabled={busy} onClick={() => acao("checklist", { avaliacao_id: it.avaliacao_id })} data-testid={`demo-avaliacao-checklist-${it.n}`}
            className="px-2 py-1 rounded bg-[#126BFF]/15 text-[#6FA6FF] font-bold">Empresa: checklist técnico</button>
        </div>
      )}
      {!decidida && (
        <div className="mt-2 flex flex-wrap gap-1.5 items-center">
          <select value={conc} onChange={e => setConc(e.target.value)} data-testid={`demo-avaliacao-conclusao-${it.n}`}
            className="bg-[#142766] border border-[#FFCC00]/30 rounded-lg text-[11px] font-bold px-2 py-1">
            {CONCLUSOES.map(([v, l]) => <option key={v} value={v}>Conclusão: {l}{sugerida === v ? " (sugerida)" : ""}</option>)}
          </select>
          <select value={dest} onChange={e => setDest(e.target.value)} data-testid={`demo-avaliacao-destino-${it.n}`}
            className="bg-[#142766] border border-[#FFCC00]/30 rounded-lg text-[11px] font-bold px-2 py-1">
            {DESTINOS.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
          </select>
          <button disabled={busy} onClick={() => acao("decidir", { avaliacao_id: it.avaliacao_id, conclusao: conc, destino: dest || undefined })} data-testid={`demo-avaliacao-decidir-${it.n}`}
            className="px-2 py-1 rounded bg-[#FFCC00] text-[#0B1020] font-bold">Empresa decide</button>
        </div>
      )}
      {decidida && (
        <div className="mt-2 text-[11px] text-[#34D399]" data-testid={`demo-avaliacao-decisao-${it.n}`}>
          Decisão humana: <b>{av.conclusao_humana}</b>{av.classificacao_alterada ? ` (alterou a sugestão ${av.sugerida_pelo_motor})` : ""} → destino <b>{av.destino_operacional}</b>
          {av.garantia_id ? ` · Garantia acionada pelo fluxo real (garantia_de = OS ${it.pim_mae}, sem repasse)` : av.servico_filho_id ? " · OS filha criada pelo fluxo real" : " · sem OS filha"}
          {av.garantia_id && (
            <div className="mt-1.5 flex items-center gap-2">
              <span className="text-[#6FA6FF] font-bold">GAR {garStatus || "—"}</span>
              {garStatus !== "finalizado" && (
                <button disabled={busy} onClick={() => acao("garantia_executar", { avaliacao_id: it.avaliacao_id })} data-testid={`demo-avaliacao-garantia-executar-${it.n}`}
                  className="px-2 py-1 rounded bg-[#126BFF]/15 text-[#6FA6FF] font-bold">Montador executa a Garantia</button>
              )}
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export function AvaliacaoShowroom({ sid, itens = [], avaliacoes = [], servs = [] }) {
  const [busy, setBusy] = React.useState(false);
  const acao = async (a, body = {}) => {
    setBusy(true);
    try { await axios.post(`${API}/demo/sessao/${sid}/cenario/avaliacao/${a}`, body); toast.success("Etapa registrada pelo fluxo real"); }
    catch (e) { toast.error(e?.response?.data?.detail || "Erro"); }
    finally { setBusy(false); }
  };
  return (
    <div className="mt-5 rounded-2xl border border-[#FFCC00]/30 bg-[#FFCC00]/5 p-4" data-testid="demo-avaliacao-controles">
      <div className="flex items-center justify-between gap-2">
        <div className="font-bold text-[#FFCC00] text-sm">Avaliação Pós-Montagem — reclamação pelo fluxo real</div>
        <button disabled={busy} onClick={() => acao("reclamar")} data-testid="demo-avaliacao-reclamar"
          className="px-3 py-1.5 rounded-lg bg-[#FF6700] text-xs font-bold hover:bg-[#FF6700]/80 disabled:opacity-50">Cliente reclama</button>
      </div>
      <div className="mt-3 space-y-1.5">
        {itens.map(it => <ItemAvaliacao key={it.avaliacao_id} sid={sid} it={it} av={avaliacoes.find(a => a.id === it.avaliacao_id)} servs={servs} busy={busy} acao={acao} />)}
      </div>
      <div className="text-[10px] text-white/40 mt-2">Relato + fotos + vídeo entram por _cliente_abrir_avaliacao; o questionário roda o motor real de triagem (_triagem_pontuar) apenas como apoio; o destino e a OS filha só nascem na decisão humana (decidir_avaliacao). Nada é criado automaticamente.</div>
    </div>
  );
}
